import * as yup from 'yup';

export const clientCreateStep2Schema = (
  t: (key: string, options?: { [key: string]: string }) => string,
): yup.AnyObjectSchema =>
  yup.object().shape({
    contact: yup.object().shape({
      lastName: yup
        .string()
        .nullable()
        .max(255, t('create.errors.inputTooLong', { maxLength: '255' })),
      firstName: yup
        .string()
        .nullable()
        .max(255, t('create.errors.inputTooLong', { maxLength: '255' })),
      email: yup.string().nullable().email(t('create.errors.invalidEmail')),
      phoneNumber: yup.string().nullable(),
    }),
  });
